import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate',
})
export class CustomDatePipe implements PipeTransform {
  transform(value?: string | null): string {
    if (!value) return '--';

    const date = new Date(value);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';

    const formattedHours = this.formatHours(hours);

    return `${year}/${month}/${day} ${formattedHours}:${minutes} ${ampm}`;
  }

  private formatHours(hours: number): string {
    const formattedHour = hours % 12 || 12;
    return formattedHour.toString().padStart(2, '0');
  }
}
